import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable, map, of, switchMap, catchError } from "rxjs";
import { IDENEDI_CODE_STORAGE_KEY, AuthService as AuthServiceMain, AuthType } from './auth.stemexe.service';
import { PlannexeAppService } from "@plannexe/shared/services/plannexe-app.service";
import { LocalEnum } from "../enums/localstorage";

@Injectable({
  providedIn: "root"
})
export class PlannexeAddonResolver implements Resolve<any> {
  constructor(
    private stemexeAuthService: AuthServiceMain,
    private plannexeAppService: PlannexeAppService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    console.log('PlannexeAddonResolver');
    const local = localStorage.getItem(LocalEnum.isloggedin);
    if(!local || local != 'true'){
      return of([]);
    }
    return this.plannexeAddon().pipe(
      switchMap(addon => {
        if(addon && addon.BaseUrl){
          this.plannexeAppService.setBaseUrl(addon.BaseUrl);
        }
        return of(addon);
      }),
      catchError(error => {
        console.warn('PlannexeAddonResolver: Failed to get addon, continuing with empty addon:', error);
        return of([]);
      })
    );
  }
  plannexeAddon(): Observable<any>{
    return this.stemexeAuthService
    .getAddonsAuth(this.stemexeAuthService.idenediGroupId)
    .pipe(
      map(addons => {
        return addons.find(
          addon => addon.Type === AuthType.EngagementPro
        );
      })
    );
  }
}